import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("titles.my_notifications"))),
      ]),
      _vm._t("default"),
      _c(
        VCard,
        { staticClass: "mt-2" },
        [
          _c(VDataTable, {
            key: _vm.key_table,
            staticClass: "table-inca",
            attrs: {
              "item-class": _vm.itemClass,
              headers: _vm.headers,
              items: _vm.notifications,
              "hide-default-footer": "",
              page: _vm.pagination.current,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.pagination, "current", $event)
              },
              pagination: function ($event) {
                _vm.pagination.total = $event.itemsLength
              },
            },
            scopedSlots: _vm._u([
              {
                key: "item.actions",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    item.path
                      ? _c(
                          VBtn,
                          { attrs: { icon: "" } },
                          [
                            _c(
                              VIcon,
                              {
                                attrs: { small: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onClickNotification(item)
                                  },
                                },
                              },
                              [_vm._v(" fas fa-location-arrow ")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("pagination-firestore", {
        attrs: { pagination: _vm.pagination },
        on: { changePagina: _vm.changePage },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }